import { Link } from "react-router-dom";
import type { LinkProps } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function LocalLink({ to, children, ...props }: LinkProps) {
  const { i18n } = useTranslation();
  
  const getPath = (path: string) => {
    if (typeof path !== 'string') return path;
    if (path.startsWith('http')) return path; // Don't modify external links
    if (i18n.language === 'en' || !i18n.language) return path;
    if (path.startsWith(`/${i18n.language}/`) || path === `/${i18n.language}`) return path;
    return path === '/' ? `/${i18n.language}` : `/${i18n.language}${path}`;
  };

  return (
    <Link to={getPath(to as string)} {...props}>
      {children}
    </Link>
  );
}
